import {useState, useEffect} from "react";
import {Checkbox} from "primereact/checkbox";

const DocumentTypeSelector = ({
	cleanedFileNames = [],
	setSelectedTypes,
	enabledTemplateTypes = [],
}) => {
	const [types, setTypes] = useState([]);

	useEffect(() => {
		if (
			cleanedFileNames.length !== types.length ||
			enabledTemplateTypes.some((item, idx) => item.file_name !== types[idx]?.file_name)
		) {
			const initialCheckedFiles = cleanedFileNames.map(file => {
				const isChecked =
					enabledTemplateTypes?.some(enabledFile => enabledFile.file_name === file.file_name) ||
					false;
				return {
					...file,
					checked: isChecked,
				};
			});

			setTypes(initialCheckedFiles);
		}
	}, [cleanedFileNames, enabledTemplateTypes, types]);

	const handleCheckboxChange = file => {
		const updatedTypes = types.map(item =>
			item.file_name === file.file_name ? {...item, checked: !item.checked} : item,
		);

		setTypes(updatedTypes);

		const selected = updatedTypes.filter(item => item.checked);
		setSelectedTypes(selected);
	};

	return (
		<>
			<div className="col-12 fs-5 fw-bold opacity-50 border-bottom pb-2 mt-3 mb-4 p-0">
				Choose document types
			</div>
			<div className="d-flex align-items-center gap-2 text-center">
				{Array.isArray(cleanedFileNames) && cleanedFileNames.length > 0 ? (
					cleanedFileNames.map(file => {
						const {file_name, id} = file;
						const uniqueId = `box-${file_name}`;

						let cleanedLabel = file_name
							.split("/")[1]
							.split("_")
							.slice(1)
							.join(" ")
							.replace(/\.[^/.]+$/, "")
							.trim();

						const isChecked = types.find(item => item.file_name === file_name)?.checked;

						return (
							<div key={id} className="me-3 p-0 d-flex">
								<Checkbox
									inputId={uniqueId}
									value={file_name}
									checked={isChecked}
									onChange={() => handleCheckboxChange(file)}
								/>
								<label htmlFor={uniqueId} className="ms-2">
									{cleanedLabel}
								</label>
							</div>
						);
					})
				) : (
					<div>No document types available</div>
				)}
			</div>
		</>
	);
};

export default DocumentTypeSelector;
